import React from 'react';
import PropTypes from 'prop-types';
import { get, last, noop, times } from 'lodash-es';

import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  buildAuthorArticlesPath,
  buildAuthorVideosPath,
  EditorialEntities,
  EditorialModel,
} from 'client/data/models/editorial';

import { ARTICLE_PAGE_SIZE, PLACEHOLDER_CARDS_NUM } from './constants';
import { AuthorArticleCard } from './author-article-card';

function AuthorPageUI({ articles = [], videos = [], openVideoModal = noop }) {
  const combinedCards = [
    ...articles,
    ...videos?.map(video => ({ ...video, videoId: video.url ? last(video.url.split('/')) : '' })),
  ].map(article => ({ ...article, date: article.updateDate || article.publishDate }));

  const articlesToRender = !combinedCards.length
    ? times(PLACEHOLDER_CARDS_NUM, ind => ({ ind: ind + 1, isLoading: true }))
    : combinedCards;

  return articlesToRender.map(article => (
    <AuthorArticleCard
      key={article.ind || article.relativeUrl || article.url}
      article={article}
      openVideoModal={openVideoModal}
    />
  ));
}

AuthorPageUI.propTypes = {
  articles: EditorialEntities.Articles,
  videos: EditorialEntities.Videos,
  openVideoModal: PropTypes.func,
};

export const AuthorArticlesPage = connectToModel(AuthorPageUI, {
  articles: bindToPath(
    ({ pageNum, author }) => buildAuthorArticlesPath(author, pageNum, ARTICLE_PAGE_SIZE),
    EditorialModel,
    data => get(data, 'results', [])
  ),
});

export const AuthorVideosPage = connectToModel(AuthorPageUI, {
  videos: bindToPath(
    ({ pageNum, author }) => buildAuthorVideosPath(author, pageNum, ARTICLE_PAGE_SIZE),
    EditorialModel,
    data => get(data, 'results', [])
  ),
});
